import React, { Component } from 'react';
import axios from 'axios';

import './Input.css';
import './Button.css';
import './ContactForm.css';

class ContactForm extends Component {

  constructor(props){
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);

    this.state = {
      name:"",
      email: "",
      phone: "",
      statusOk:false,
      loading:false
    }
  }

  handleFormChange(e){
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit(e){
    e.preventDefault();
    console.log('submitting', JSON.stringify(this.state));
    this.setState({
      loading:true
    });
    // setTimeout(function () {
      this.sendEmail();

    // }.bind(this), 1000);

  }

  async sendEmail(){
    // const dest = "daniel.melkersson@ny.se, mattias.helgesson@ny.se";
    const dest = this.props.email;
    // const formValues = JSON.stringify(this.state);
    const { name, email, phone } = this.state;
    const objectName = this.props.objectName;
    const projectName = this.props.projectName;

    const details = {
      name : name,
      email : email,
      phone : phone,
      objectName : objectName,
      projectName : projectName
    }


    let url = "https://us-central1-ranagard-9e27f.cloudfunctions.net/sendMail?dest=" + dest;

    await axios.post(
      url,
      { details },
      { headers: { 'Content-Type': 'application/json' } }
    ).then(function(response){
      console.log(response.status)
      if(response.status === 200){

        this.setState({
          statusOk:true,
          loading:false
        })
      }

    }.bind(this))
  }

  render() {

    return (
      <form onSubmit={this.handleSubmit} className={this.state.statusOk ? "contact-form form-submitted" : "contact-form " }>
      <h3>Fyll i formuläret nedan</h3>

        <input name="name"  type="name"  onChange={this.handleFormChange} value={this.state.name} placeholder="Namn" required />
        <input name="phone" type="tel" onChange={this.handleFormChange} value={this.state.phone} placeholder="Telefonnummer" required />
        <input name="email" type="email" onChange={this.handleFormChange} value={this.state.email} placeholder="E-post" required />
        <button className={this.state.loading ? "waiting-response" : ""} type="submit" value="Skicka">Skicka</button>
      </form>
    );
  }
}

export default ContactForm;
